export const initialOrganization = {
  name: '',
  description: '',
  id: '',
  properties: {},
  streams: [],
  metadata: {
    createdBy: '',
    createdAt: '',
    private: true,
    coverPicUrl: '',
    profilePicUrl: '',
  },
};
